import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Button } from '@cropler/ui-kit';

import stylesModal from '../../styles/modal.module.scss';
import { sensorsApi, useDeleteLocationMutation } from '../../store/api/sensors';
import { Trans } from 'react-i18next';
import { Icon as CroplerIcon } from '@cropler/ui-kit';

const LocationRemoveForm = ({ t, location = { id: '', name: '' }, closeModal }) => {
  const dispatch = useDispatch();
  const [deleteLocation, { isSuccess: isDeleteLocationSuccess }] = useDeleteLocationMutation();

  const onDeleteField = () => {
    deleteLocation({ id: location.id });
    closeModal();
  };

  useEffect(() => {
    if (isDeleteLocationSuccess) {
      setTimeout(() => {
        dispatch(sensorsApi.util.resetApiState());
      });
    }
  }, [isDeleteLocationSuccess]);

  return (
    <>
      <p>
        <Trans
          i18nKey={'locations.deleteLocationText'}
          values={{ name: location.name }}
          components={{ strong: <strong /> }}
        />
      </p>
      <div className={stylesModal.modalNav}>
        <Button type="secondary" onClick={closeModal}>
          {t('actions.cancel')}
        </Button>
        <Button type="danger" icon={<CroplerIcon name="remove" />} onClick={() => onDeleteField()}>
          {t('actions.delete')}
        </Button>
      </div>
    </>
  );
};

export default LocationRemoveForm;
